import React, { useState } from 'react';
import { Icon, Button, Modal, Header } from 'semantic-ui-react';
export const DeleteButton = ({ onConfirm, title = "Confirm Delete", message = "Are you sure you want to delete this item? This action cannot be undone.", iconOnly = false, buttonText = 'Delete', style, }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleClick = (e) => {
        e.stopPropagation();
        setIsModalOpen(true);
    };
    const handleConfirm = () => {
        onConfirm();
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    return (React.createElement(React.Fragment, null,
        iconOnly ? (
        // Avoid semantic-ui Popup (uses findDOMNode under StrictMode). Use native title tooltip instead.
        React.createElement("span", { style: { display: 'inline-flex' }, title: title },
            React.createElement(Icon, { name: "trash", color: "grey", link: true, onClick: handleClick, style: style }))) : (
        // Avoid semantic-ui Popup (uses findDOMNode under StrictMode). Use native title tooltip instead.
        React.createElement("span", { style: { display: 'inline-flex' }, title: title },
            React.createElement(Button, { size: "mini", color: "red", onClick: handleClick, style: style },
                React.createElement(Icon, { name: "trash" }),
                buttonText))),
        React.createElement(Modal, { open: isModalOpen, onClose: handleCancel, size: "small" },
            React.createElement(Header, { icon: "trash", content: title }),
            React.createElement(Modal.Content, null,
                React.createElement("p", null, message)),
            React.createElement(Modal.Actions, null,
                React.createElement(Button, { onClick: handleCancel }, "Cancel"),
                React.createElement(Button, { color: "red", onClick: handleConfirm, icon: "trash", labelPosition: "left", content: "Delete" })))));
};
